import useScreenSize from "../../hooks/useScreenSize"
import { Avatar } from "@mui/material"
import Button from "../../components/button/Button"
import './facultyProfile.scss'
import { useState, useEffect } from 'react'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { useDispatch, useSelector } from 'react-redux'
import {
  getFacultyBankDetails,
  getFacultyProfile,
  getFacultyProfilePhoto,
  updateFacultyProfilePhoto,
} from '../../store/builders/facultyProfile/facultyProfile.builder'
import { capitalizeFirstLetter } from '../../utility/genricFunction'
import Loader from '../../components/loader/Loader'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'

function FacultyProfile() {
  const screenSize = useScreenSize()
  const dispatch = useDispatch()
  const { facultyId } = useSelector((state) => state.auth.user.result)
  const { FacultyProfileInfo, facultyBankDetails, facultyProfilePhoto, loading } = useSelector(
    (state) => state.facultyProfile,
  )
  const [profilePhoto, setProfilePhoto] = useState(null)
  const [profilePhotoPreview, setProfilePhotoPreview] = useState(profilePhoto)
  const [isLocked, setIsLocked] = useState(true)

  useEffect(() => {
    dispatch(getFacultyBankDetails(facultyId))
    dispatch(getFacultyProfilePhoto(facultyId))
    dispatch(getFacultyProfile(facultyId))

    return () => dispatch({ type: 'facultyProfile/clearExtraReducers' })
  }, [dispatch, facultyId])

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.MY_PROFILE,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.FACULTY_DASHBOARD,
    },
    {
      title: UI_CONSTANT.MY_PROFILE,
      link: ROUTES_PATH.FACULTY_PROFILE,
    },
  ]

  const formatDate = (dateString) => {
    if (dateString != null) {
      const date = new Date(dateString)
      return date.toLocaleDateString() // You can pass a locale string as an argument, e.g., 'en-US'
    }
    return 'N/A'
  }

  const handleProfilePhotoChange = (event) => {
    const file = event.target.files[0]

    if (file) {
      setProfilePhoto(file)
      setProfilePhotoPreview(URL.createObjectURL(file))
      dispatch(updateFacultyProfilePhoto({ profilePhoto: file, facultyId, dispatch }))
    }
  }

  const handleEditIconClick = () => {
    document.getElementById('profilePhotoInput').click()
  }

  const toggleLock = () => {
    setIsLocked(!isLocked)
  }

  return (
    <>
      {loading && <Loader loading={loading} />}
      <div className={`course-list ${screenSize}`}>
        <div className='filter-bar-wraper'>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
          </div>
        </div>
        <div className='faculty-profile-wrapper'>
          <div className='faculty-avatar-wrapper'>
            <div className='profile-img-div'>
              <Avatar
                alt=''
                src={profilePhotoPreview || facultyProfilePhoto?.userPhotoUrl}
                className='faculty-profile-avatar'
              />
            </div>

            <input
              type='file'
              id='profilePhotoInput'
              accept='image/*'
              onChange={handleProfilePhotoChange}
              className='file-input'
              style={{ display: 'none' }}
            />
            <div className='faculty-details'>
              <h1 className='student-name'>{FacultyProfileInfo?.userName}</h1>
              <h4 className='faculty-profile-subtitle'>Faculty</h4>
              <div className='faculty-personal-detail'>
                <div>
                  Email: <span>{FacultyProfileInfo?.userEmail}</span>
                </div>
                <hr />
                <div>
                  Mobile: <span>+91-{FacultyProfileInfo?.userPhone}</span>
                </div>
              </div>
            </div>
          </div>
          <Button customClassName='btn-edit-profile' onClick={handleEditIconClick}>
            {UI_CONSTANT.EDIT_PROFILE}
          </Button>
        </div>

        <div className='faculty-profile-group-parent'>
          <div className='personal-info-title'>Faculty Information</div>
          <div>
            <table className='personal-info-table' id='academic-details-student-profile'>
              <tr className='display-data-row-first'>
                <td>Faculty Address</td>
                <td></td>
                <td>State</td>
                <td>City</td>
                <td>Faculty Area</td>
              </tr>
              <tr className='display-data-row-second'>
                <td>{capitalizeFirstLetter(FacultyProfileInfo?.userAddress1)}</td>
                <td></td>
                <td>{FacultyProfileInfo?.state?.stateName}</td>
                <td>{FacultyProfileInfo?.city?.cityName}</td>
                <td>{FacultyProfileInfo?.area?.areaName}</td>
              </tr>
            </table>
            <div className='faculty-about-cantant'>
              <p className='faculty-about'>About Faculty:</p>
              <div className='faculty-about-desc'>{capitalizeFirstLetter(FacultyProfileInfo?.facultyAbout)}</div>
            </div>
          </div>
        </div>

        <div className='faculty-profile-group-parent sub-div-student'>
          <div className='personal-info-title'>Billing Info</div>
          {isLocked && <LockOutlinedIcon className='faculty-lock' onClick={toggleLock} />}
          <div>
            <table className={`personal-info-table ${!isLocked ? '' : 'blur'}`} id='academic-details-student-profile'>
              <tr className='display-data-row-first'>
                <td>Hourly Rate</td>
                <td></td>
                <td className='school-name'>Applicable Date</td>
              </tr>
              <tr className='display-data-row-second'>
                <td>{FacultyProfileInfo?.hourlyRate ? `₹${FacultyProfileInfo?.hourlyRate}` : 'N/A'}</td>
                <td></td>
                <td>
                  {FacultyProfileInfo?.rateEffectiveDate ? formatDate(FacultyProfileInfo?.rateEffectiveDate) : 'N/A'}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div className='faculty-profile-group-parent sub-div-student'>
          <div className='personal-info-title'>Bank Information</div>
          <div>
            <table className='personal-info-table' id='academic-details-student-profile'>
              <tr className='display-data-row-first'>
                <td className='company-name'>Bank</td>
                <td></td>
                <td>Account No</td>
                <td>IFSC Code</td>
                <td>Branch</td>
              </tr>
              <tr className='display-data-row-second'>
                <td>{capitalizeFirstLetter(facultyBankDetails?.facultyBankName)}</td>
                <td></td>
                <td>{facultyBankDetails?.facultyBankAccountNo}</td>
                <td>{facultyBankDetails?.facultyBankIfscCode}</td>
                <td>{capitalizeFirstLetter(facultyBankDetails?.facultyBankBranchName)}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default FacultyProfile
